// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsights_container__11T4B"};